import { DeviceInfo } from "@magalu/rave/router";

export type GetPlatformEnvsProps = {
  clientConfig?: {
    platform?: {
      desktop?: {
        baseUrl?: string;
        cart?: {
          host?: string;
        };
      };
      mobile?: {
        baseUrl?: string;
        cart?: {
          host?: string;
        };
      };
    };
  };
  data?: Record<string, unknown>;
  route?: {
    deviceInfo: DeviceInfo;
  };
};

const getPlatformEnvs = (_ctx: unknown, props: GetPlatformEnvsProps) => {
  const { clientConfig, route } = props;

  const isMobile = !!route?.deviceInfo?.type;

  if (!props.data) {
    props.data = {};
  }

  props.data.platform = {
    ...(isMobile
      ? clientConfig?.platform?.mobile
      : clientConfig?.platform?.desktop),
  };
};

export default getPlatformEnvs;
